export default class TimesheetReportRequest {
    shiftWeekCommencing: string;
    approvedOnOrAfter: string;
}